import PersonalAccessTokens from './PersonalAccessTokens';
import reducer from './PersonalAccessTokensReducer';

export const reducers = { personalAccessTokens: reducer };

export default PersonalAccessTokens;
